import {
  HHButton,
  HHSelect,
  HHSelectChangeEvent,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { Dispatch, SetStateAction } from 'react';
import {
  DateRangePicker,
  DateRangePickerValue,
} from '../../components/date-range-picker';
import {
  assessmentTasksTabContent,
  AssessmentTaskStatus,
} from '../constants/assessment-tasks.constant';

interface AssessmentTasksToolbarProps {
  dateRange: [DateRangePickerValue, DateRangePickerValue];
  setDateRange: Dispatch<
    SetStateAction<[DateRangePickerValue, DateRangePickerValue]>
  >;
  selectedStatus: AssessmentTaskStatus | '';
  setSelectedStatus: Dispatch<SetStateAction<AssessmentTaskStatus | ''>>;
}

export const AssessmentTasksToolbar = ({
  dateRange,
  setDateRange,
  selectedStatus,
  setSelectedStatus,
}: AssessmentTasksToolbarProps): JSX.Element => {
  const statusOptions = Object.values(AssessmentTaskStatus).map(status => ({
    value: status,
    displayName: status,
  }));

  const handleStatusChange = (e: HHSelectChangeEvent): void => {
    setSelectedStatus(e.target.value as AssessmentTaskStatus);
  };

  return (
    <HHStack direction="row" spacing={6} alignItems="center">
      <HHTypography hhVariant="h3">
        {assessmentTasksTabContent.filters.label}
      </HHTypography>
      <HHSelect
        data-testid="status-select"
        label="Status"
        selectOptions={[{ value: '', displayName: '' }, ...statusOptions]}
        onChange={handleStatusChange}
        initialSelectValue={selectedStatus}
      />
      <DateRangePicker
        dateRange={dateRange}
        setDateRange={setDateRange}
        startDateTestId="earliest-filter"
        endDateTestId="latest-filter"
      />
      <HHButton
        data-testid="clear-button"
        hhVariant="variant-bypass"
        disabled={!selectedStatus && !dateRange[0] && !dateRange[1]}
        onClick={(): void => {
          setSelectedStatus('');
          setDateRange([null, null]);
        }}
      >
        {assessmentTasksTabContent.filters.clear}
      </HHButton>
    </HHStack>
  );
};
